export enum DeleteUserStatus {
  Delete = 'DELETE',
  Archive = 'ARCHIVE',
}
